var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 main-menu"},[_c('sidebar-menu',{staticClass:"side-menu",attrs:{"menu":_vm.menu,"enable-collapsing":_vm.getUserData.enable_menu_collapsing,"theme":"white-theme"},on:{"collapse":_vm.onCollapse,"item-expanded":_vm.itemExpanded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }